export const COLUMNS = [
  {
    Header: 'Id',
    accessor: 'id'
  },
  {
    Header: 'Product',
    accessor: 'product_name'
  },
  {
    Header: 'Category',
    accessor: 'category'
  },
  {
    Header: 'Description',
    accessor: 'description'
  },
  {
    Header: 'Price',
    accessor: 'price'
  },
  {
    Header: 'Stock',
    accessor: 'stock'
  },
  
]